import { useState, useEffect, useRef, } from "react";
import { useContext, useMemo } from "react";
import LevelTransmitterIndicator from "../components/LevelTransmitterIndicator";
import Transmitter from "../components/Transmitter";
import ControlValveControlPanel from "../components/ControlValveControlPanel";
import Valve from "../components/Valve";
import "./SurgeTank.css";
import { WellContext } from "../context/WellContext";
import { AlarmContext } from "../context/AlarmContext";
import { PumpContext } from "../context/PumpContext"; 
import { ProcessContext } from "../context/ProcessContext";
import Pump from "../components/Pump";
import PumpFaceplate from "../components/PumpFaceplate";
import { PlantStore } from "../engine/PlantStore";
import { usePlantStore } from "../engine/usePlantStore";


import { trackPageVisit } from "../competency/PageTracker";
import TransmitterFaceplate from "../components/TransmitterFaceplate";





function ValveOutput({
    tag,
    value,
    x,
    y,
    r = 0,
    description = "Control Valve Opening"
}) {

    const [hover, setHover] = useState(false);
    const [showFaceplate, setShowFaceplate] = useState(false);

    return (
        <>
            {/* Hover */}
            {hover && (
                <div
                    style={{
                        position: "absolute",
                        left: x + 30,
                        top: y - 5,
                        background: "rgba(0,80,180,.85)",
                        color: "#fff",
                        padding: "5px 8px",
                        borderRadius: "4px",
                        border: "1px solid #4fc3ff",
                        fontSize: "11px",
                        zIndex: 9999,
                        pointerEvents: "none",
                        whiteSpace: "nowrap"
                    }}
                >
                    <strong>{tag}</strong><br />
                    {description}
                </div>
            )}

            {/* Original Valve Output */}
            <div
                onMouseEnter={() => setHover(true)}
                onMouseLeave={() => setHover(false)}
                onClick={() => setShowFaceplate(true)}
                style={{
                    position: "absolute",
                    left: x,
                    top: y,

                    color: "lime",
                    background: "black",

                    fontSize: "10px",
                    padding: "1px 4px",

                    borderRadius: "4px",
                    border: "1px solid #555",

                    transform: `rotate(${r}deg)`,
                    transformOrigin: "center",

                    cursor: "pointer",

                    fontWeight: "bold",

                    minWidth: "22px",
                    textAlign: "center",

                    transition: "0.2s",
                    boxShadow: hover
                        ? "0 0 8px rgba(0,255,255,.7)"
                        : "none"
                }}
            >
                {Number(value).toFixed(1)} %
            </div>

            {showFaceplate && (
                <TransmitterFaceplate
                    tag={tag}
                    value={Number(value)}
                    unit="%"
                    min={0}
                    max={100}
                    HH={100}
                    H={90}
                    L={10}
                    LL={0}
                    description={description}
                    x={x + 35}
                    y={y + 20}
                    onClose={() => setShowFaceplate(false)}
                />
            )}
        </>
    );
}




function SurgeTank() {

    useEffect(() => {
    
      trackPageVisit("SurgeTank");
    
    }, []);
  
     const {  valves, toggleValve} = useContext(WellContext);

const [hoveredValve, setHoveredValve] = useState(null);
const {processData,  setProcessData} = useContext(ProcessContext);


     

  const DEFAULT_VALVES = {
  FCV_2701: { mode: "Manual", opening: 0, sp: "", pv: "" },
  FCV_2702: { mode: "Manual", opening: 0, sp: "", pv: "" },
  FCV_2703: { mode: "Manual", opening: 0, sp: "", pv: "" },
  FCV_2704: { mode: "Manual", opening: 0, sp: "", pv: "" },

};

const [valveData, setValveData] = useState(() => {
  const saved = localStorage.getItem("SurgeTank_valveData");

  if (!saved) return DEFAULT_VALVES;

  try {
    const parsed = JSON.parse(saved);

    // ✅ Merge saved + default (CRITICAL)
    return {
      FCV_2701: { ...DEFAULT_VALVES.FCV_2701, ...parsed.FCV_2701 },
      FCV_2702: { ...DEFAULT_VALVES.FCV_2702, ...parsed.FCV_2702 },
      FCV_2703: { ...DEFAULT_VALVES.FCV_2703, ...parsed.FCV_2703 },
      FCV_2704: { ...DEFAULT_VALVES.FCV_2704, ...parsed.FCV_2704 },

    };

  } catch {
    return DEFAULT_VALVES;
  }
});



/* ✅ Persist */
  useEffect(() => {
    localStorage.setItem("SurgeTank_valveData", JSON.stringify(valveData));
  }, [valveData]);

  /* ================= ✅ FIXED UPDATE FUNCTION ================= */
  const updateValveData = (tag, field, value) => {
  setValveData(prev => ({
    ...prev,
    [tag]: {
      ...(prev[tag] || DEFAULT_VALVES[tag]),
      [field]: field === "opening" ? Number(value) || 0 : value
    }
  }));
};

  /* ================= PANEL CONTROL ================= */
  const [openPanels, setOpenPanels] = useState([]);

  const openPanel = (tag) => {
    if (!openPanels.includes(tag)) {
      setOpenPanels(prev => [...prev, tag]);
    }
  };

  const closePanel = (tag) => {
    setOpenPanels(prev => prev.filter(p => p !== tag));
  };


  // ================= PUMP PANEL LOGIC =================

  const [openPumpPanels, setOpenPumpPanels] = useState([]);

const openPumpPanel = (tag) => {
  if (!openPumpPanels.includes(tag)) {
    setOpenPumpPanels(prev => [...prev, tag]);
  }
};

const closePumpPanel = (tag) => {
  setOpenPumpPanels(prev => prev.filter(p => p !== tag));
};





const [panelPos, setPanelPos] = useState({ x: 0, y: 80 });
const [dragging, setDragging] = useState(false);
const offsetRef = useRef({ x: 0, y: 0 });

const handleMouseDown = (e) => {
  setDragging(true);

  offsetRef.current = {
    x: e.clientX - panelPos.x,
    y: e.clientY - panelPos.y,
  };
};

const handleMouseMove = (e) => {
  if (!dragging) return;

  setPanelPos({
    x: e.clientX - offsetRef.current.x,
    y: e.clientY - offsetRef.current.y,
  });
};

const handleMouseUp = () => {
  setDragging(false);
};

useEffect(() => {
  window.addEventListener("mousemove", handleMouseMove);
  window.addEventListener("mouseup", handleMouseUp);

  return () => {
    window.removeEventListener("mousemove", handleMouseMove);
    window.removeEventListener("mouseup", handleMouseUp);
  };
}, [dragging]);




const tagStyle = {
      position: "absolute",
      top: -30,
      left: "50%",
      transform: "translateX(-50%)",

      background: "black",
      color: "#00ffcc",

      fontSize: "13px",
      fontWeight: "bold",

      padding: "3px 8px",
      borderRadius: "4px",

      border: "1px solid #555",

      whiteSpace: "nowrap",
      zIndex: 999
    };


// ================= RETREIVING OF DATA FROM OTHER PAGES VIA LOCAL STROAGE =================

  
            const { transmitters,  flowOverrides} = usePlantStore();
            const FIC_18007 = transmitters.FIC_18007 || 0;
            const TT_18007 = transmitters.TT_18007 || 0;
            const PT_18007 = transmitters.PT_18007 || 0;
            const FIC_2607 = transmitters.FIC_2607 || 0;
            const TT_2607 = transmitters.TT_2607 || 0;
            const PT_2607 = transmitters.PT_2607 || 0;
            const TT_28020 = transmitters.TT_28020 || 0;






  const xv2701Open = !valves?.XV_2701;
  const xv2702Open = !valves?.XV_2702;
  const xv2703Open = !valves?.XV_2703;
  const xv2704Open = !valves?.XV_2704;


  const FIC_2701 = FIC_18007;
  const TT_2701 = TT_18007;
  const PT_2701 = PT_18007;


  const FIC_2702 = FIC_2607;
  const TT_2702 = TT_2607;
  const PT_2702 = PT_2607;

  const PT_2704 = xv2703Open ? 0.46 : 0.03;
  const FIC_2704 = xv2703Open ? 1.46 : 0.03;
  const FIC_2708 = xv2704Open ? 3.46 : 0.03;


const AtmosphericTemperature = 32;


  // 1. Check instrument health / signal validity (Adjust bounds based on your process range)
const isTT2701_Valid = (typeof TT_2701 === 'number') && (TT_2701 >= 35 && TT_2701 <= 400);
const isTT2702_Valid = (typeof TT_2702 === 'number') && (TT_2702 >= 35 && TT_2702 <= 400);

// 2. Read flow rates (Clamp negative readings to 0 to prevent math distortions)
const flow1 = (typeof FIC_2701 === 'number' && FIC_2701 > 0) ? FIC_2701 : 0;
const flow2 = (typeof FIC_2702 === 'number' && FIC_2702 > 0) ? FIC_2702 : 0;

let TT_2703;

// 3. Availability Matrix Resolution
if (isTT2701_Valid && isTT2702_Valid) {
    const totalFlow = flow1 + flow2;
    
    if (totalFlow > 0) {
        // Thermodynamically sound flow-weighted blend
        TT_2703 = ((TT_2701 * flow1) + (TT_2702 * flow2)) / totalFlow;
    } else {
        // Both valid but stagnant lines; use arithmetic mean as fallback
        TT_2703 = (TT_2701 + TT_2702) / 2;
    }
} 
else if (isTT2701_Valid) {
    // TT_2702 failed or out-of-bounds; assume the vessel holds TT_2701 temperature
    TT_2703 = TT_2701;
} 
else if (isTT2702_Valid) {
    // TT_2701 failed or out-of-bounds; assume the vessel holds TT_2702 temperature
    TT_2703 = TT_2702;
} 
else {
    // CRITICAL CRASH PROTECTION: Both instruments failed or are offline.
    // Fall back to a dedicated vessel sensor (e.g., TT_2703) or a safe process default value.
    TT_2703 = 32; 
}



// 1. Check instrument health / signal validity (Adjust bounds based on operating pressure, e.g., 0 to 50 barg)
const isPT2701_Valid = (typeof PT_2701 === 'number') && (PT_2701 >= 0 && PT_2701 <= 100);
const isPT2702_Valid = (typeof PT_2702 === 'number') && (PT_2702 >= 0 && PT_2702 <= 100);


let PT_2703;

// 3. Availability and Logic Matrix
if (isPT2701_Valid && isPT2702_Valid) {
    
    if (flow1 > 0 && flow2 > 0) {
        // OPTION A: Average Select (Best for normal control/soft-sensors when both lines are active)
        PT_2703 = (PT_2701 + PT_2702) / 2 + (PT_2704 * (valveData?.FCV_2702?.opening || 0)/100);
        
        // OPTION B: High-Select (Uncomment if using this for safety interlocks/overpressure protection)
        // PT_2703 = Math.max(PT_2701, PT_2702);
    } 
    else if (flow1 > 0) {
        // Only Line 1 is flowing; Line 2 might be blocked in, isolated, or depressurized
        PT_2703 = PT_2701 + (PT_2704 * (valveData?.FCV_2702?.opening || 0)/100);
    } 
    else if (flow2 > 0) {
        // Only Line 2 is flowing
        PT_2703 = PT_2702 + (PT_2704 * (valveData?.FCV_2702?.opening || 0)/100);
    } 
    else {
        // Both lines are stagnant/blocked in. Take the maximum trapped pressure for safety
        PT_2703 = Math.max(PT_2701, PT_2702) + (PT_2704 * (valveData?.FCV_2702?.opening || 0)/100);
    }
} 
else if (isPT2701_Valid) {
    // PT_2702 failed; trust Line 1 pressure
    PT_2703 = PT_2701 + (PT_2704 * (valveData?.FCV_2702?.opening || 0)/100);
} 
else if (isPT2702_Valid) {
    // PT_2701 failed; trust Line 2 pressure
    PT_2703 = PT_2702 + (PT_2704 * (valveData?.FCV_2702?.opening || 0)/100);
} 
else {
    // CRITICAL CRASH PROTECTION: Both transmitters are offline.
    // Fall back to a dedicated vessel body transmitter (e.g., PT_2703) or a safe design operating pressure.
    PT_2703 = 0.03; 
}





  const FIC_2705 = ((FIC_2701 + FIC_2702)*0.02 * 5.614 + (FIC_2704 * (valveData?.FCV_2702?.opening || 0)/100)) * (valveData?.FCV_2703?.opening || 0)/100;
  const TT_2705 = (valveData?.FCV_2703?.opening || 0)/100 > 0 ? TT_2703 : 32;
  const PT_2705 = (valveData?.FCV_2703?.opening || 0)/100 > 0 ? PT_2703 + (PT_2704 * (valveData?.FCV_2702?.opening || 0)/100) : 0.03;

  const FIC_2706 = flowOverrides?.FIC_2706 ? 0 : (3.543 * (valveData?.FCV_2701?.opening || 0)/100);
  const TT_2706 = (valveData?.FCV_2701?.opening || 0)/100 > 0 ? TT_2703 : 32;
  const PT_2706 = (valveData?.FCV_2701?.opening || 0)/100 > 0 ? PT_2703*0.87 : 0.03;


  




  /* =========================================================
   PUMP CONTEXT
========================================================= */

const pumpContext = useContext(PumpContext) || {};
const pumpData = pumpContext.pumpData || {};


/* =========================================================
   P-301A / P-301B STATUS
========================================================= */

const P301A_Running =
  pumpData?.["P-301A"]?.running ?? false;

const P301B_Running =
  pumpData?.["P-301B"]?.running ?? false;


/* =========================================================
   NUMBER OF RUNNING PUMPS
========================================================= */

const RunningP301Pumps =
  (P301A_Running ? 1 : 0) +
  (P301B_Running ? 1 : 0);


/* =========================================================
   SUCTION SHUTDOWN VALVE
========================================================= */

const Pump301Available =
  xv2701Open;


/* =========================================================
   TOTAL CAPACITY
========================================================= */

const P301_CAPACITY =
  RunningP301Pumps * 6.343;


/* =========================================================
   FCV-2704 OPENING
========================================================= */

const FCV2704_Opening =
  (valveData?.FCV_2704?.opening || 0) / 100;


/* =========================================================
   TARGET FLOW
========================================================= */

const targetFIC_2707 =
(
  RunningP301Pumps > 0 &&
  Pump301Available
)
?
(
  P301_CAPACITY *
  FCV2704_Opening
)
:
0;


/* =========================================================
   FIC-2707
========================================================= */

const FIC_2707 = flowOverrides?.FIC_2706 ? 0 : (processData.FIC_2707 || 0);

useEffect(() => {

  const lastUpdate =
    Number(
      localStorage.getItem(
        "FIC_2707_LastUpdate"
      )
    ) || Date.now();

  const elapsedSeconds =
    (Date.now() - lastUpdate) / 1000;

  if (elapsedSeconds <= 1) return;

  setProcessData(prev => {

    const current =
      Number(prev.FIC_2707 || 0);

    let next = current;

    const systemActive =
      P301A_Running ||
      P301B_Running;

    const target =
      systemActive
        ? targetFIC_2707
        : 0;

    /* ====================================
       MAXIMUM 100 SCANS
       ==================================== */

    const scans =
      Math.min(
        Math.floor(
          elapsedSeconds * 10
        ),
        100
      );

    for (
      let i = 0;
      i < scans;
      i++
    ) {

      next =
        next +
        (
          target -
          next
        ) * 0.12;

    }

    return {
      ...prev,
      FIC_2707: Number(
        next.toFixed(3)
      )
    };

  });

}, [
  targetFIC_2707,
  P301A_Running,
  P301B_Running
]);



useEffect(() => {

  localStorage.setItem(
    "FIC_2707_LastUpdate",
    String(Date.now())
  );

}, [FIC_2707]);




useEffect(() => {

  const timer = setInterval(() => {

    setProcessData(prev => {

      const current =
        Number(prev.FIC_2707 || 0);

      const target =
        Number(targetFIC_2707 || 0);

      const next =
        current +
        (target - current) * 0.12;

      return {
        ...prev,
        FIC_2707: Number(next.toFixed(3))
      };

    });

  }, 500);

  return () => clearInterval(timer);

}, [targetFIC_2707]);


/* =========================================================
   PT-2707
========================================================= */

let targetPT_2707 = 0.03;

if (
  RunningP301Pumps > 0 &&
  Pump301Available &&
  FCV2704_Opening >= 0.30
) {

  targetPT_2707 = 1.20;

}

/* ==========================================
   RESTRICTED FLOW REGION
========================================== */

else if (
  RunningP301Pumps > 0 &&
  Pump301Available &&
  FCV2704_Opening > 0 &&
  FCV2704_Opening < 0.28
) {

  const restrictionFactor =
    (0.28 - FCV2704_Opening) / 0.28;

  targetPT_2707 =
    1.20 -
    (restrictionFactor * 0.45);

}


/* =========================================================
   PT-2707 ACTUAL
========================================================= */

const PT_2707 =
  Number(
    targetPT_2707.toFixed(3)
  );


/* =========================================================
   TT-2707
========================================================= */

const SuctionTemperature =
Number.isFinite(TT_2703)
  ? TT_2703
  : AtmosphericTemperature;

let targetTT_2707 = AtmosphericTemperature;

if (
    RunningP301Pumps > 0 &&
    Pump301Available
) {

    targetTT_2707 = SuctionTemperature;

    // Valve restriction heating
    if (
        FCV2704_Opening > 0 &&
        FCV2704_Opening < 0.28
    ) {

        const restriction =
            (0.28 - FCV2704_Opening) / 0.28;

        targetTT_2707 =
            SuctionTemperature +
            restriction * 8;
    }

    // Dead-head heating
    else if (FCV2704_Opening === 0) {

        targetTT_2707 =
            SuctionTemperature + 10;
    }
}

const TT_2707 =
Number(targetTT_2707.toFixed(2));


const TT_2709 = xv2702Open ? TT_28020 : 32;



/* =========================================================
   E-301A/B NAPHTHA ↔ STABILIZED NAPHTHA
   FEED/BOTTOMS HEAT EXCHANGER
========================================================= */

const TT_2708 = processData.TT_2708;
const TT_27010 = processData.TT_27010;

/* =========================================================
   REFS
========================================================= */

const E301_intervalRef = useRef(null);
const E301_isMounted = useRef(false);

const E301_processRef = useRef({});

/* =========================================================
   KEEP PROCESS VALUES UPDATED
========================================================= */

useEffect(() => {

  E301_processRef.current = {

    TT_2707,
    TT_2709

  };

});

/* =========================================================
   E-301 HEAT EXCHANGER
========================================================= */

useEffect(() => {

  if (E301_isMounted.current) return;

  E301_isMounted.current = true;

  console.log(
    "✅ E-301 interval created"
  );

  E301_intervalRef.current = setInterval(() => {

    const {

      TT_2707,
      TT_2709

    } = E301_processRef.current;


    /* =====================================
       INLETS
    ===================================== */

    const stream1 =
      Number(TT_2707) || 0;

    const stream2 =
      Number(TT_2709) || 0;


    let targetTT2708 =
      stream1;

    let targetTT27010 =
      stream2;


    /* =====================================
       DETERMINE HOT/COLD STREAM
    ===================================== */

    const hotter =
      Math.max(stream1, stream2);

    const colder =
      Math.min(stream1, stream2);

    const deltaT =
      hotter - colder;


    /* =====================================
       HEAT EXCHANGE
    ===================================== */

    if (deltaT > 0.05) {

      /*
        Feed/Bottom exchanger
        Higher effectiveness
      */

      const effectiveness = 0.35;

      const duty = Math.max(
        0.30,
        deltaT * effectiveness
      );

      const secondaryDuty =
        duty * 0.85;

      if (stream1 >= stream2) {

        targetTT2708 =
          stream1 - duty;

        targetTT27010 =
          stream2 + secondaryDuty;

      }

      else {

        targetTT2708 =
          stream1 + secondaryDuty;

        targetTT27010 =
          stream2 - duty;

      }

    }


    /* =====================================
       PHYSICAL LIMITS
    ===================================== */

    if (stream1 >= stream2) {

      targetTT2708 =
        Math.max(
          targetTT2708,
          stream2 + 2
        );

      targetTT27010 =
        Math.min(
          targetTT27010,
          stream1 - 2
        );

    }

    else {

      targetTT27010 =
        Math.max(
          targetTT27010,
          stream1 + 2
        );

      targetTT2708 =
        Math.min(
          targetTT2708,
          stream2 - 2
        );

    }


    /* =====================================
       THERMAL LAG
    ===================================== */

    setProcessData(prev => ({

      ...prev,

      TT_2708: Number(

        (

          (prev.TT_2708 ?? stream1)

          +

          (

            targetTT2708 -

            (prev.TT_2708 ?? stream1)

          ) * 0.10

        ).toFixed(2)

      ),

      TT_27010: Number(

        (

          (prev.TT_27010 ?? stream2)

          +

          (

            targetTT27010 -

            (prev.TT_27010 ?? stream2)

          ) * 0.10

        ).toFixed(2)

      )

    }));

  }, 1000);

  return () => {

    console.log(
      "❌ E-301 interval cleared"
    );

    if (E301_intervalRef.current) {

      clearInterval(
        E301_intervalRef.current
      );

      E301_intervalRef.current =
        null;

    }

    E301_isMounted.current =
      false;

  };

}, []);








useEffect(() => {

  const current =
    PlantStore.get().transmitters;


  if (
    current.TT_2708 === TT_2708 &&
    current.FIC_2707 === FIC_2707 && 
    current.PT_2707 === PT_2707 &&
    current.TT_27010 === TT_27010 &&
    current.TT_2705 === TT_2705 &&
    current.FIC_2705 === FIC_2705 &&
    current.PT_2705 === PT_2705 &&
    current.TT_2706 === TT_2706 &&
    current.FIC_2706 === FIC_2706 &&
    current.PT_2706 === PT_2706
  ) {
    return;
  }


  PlantStore.set({
    transmitters: {

      ...current,
      TT_2708, FIC_2707, PT_2707, TT_27010, FIC_2705, PT_2705, TT_2706, FIC_2706, PT_2706, 
    }
  });

}, [TT_2708, FIC_2707, PT_2707, TT_27010, TT_2705, FIC_2705, PT_2705, TT_2706, FIC_2706, PT_2706,]);




  return (
    <div className="SurgeTank-container">

      {/* TITLE */}
      <h2
        style={{
          position: "absolute",
          top: "0px",
          left: "250px",
          color: "white",
          background: "rgb(30, 5, 250)",
          padding: "2px 236px",
          zIndex: 10,
        }}
      >
        STABILIZER FEED SURGE TANK
      </h2>


 {/* =================SHUTDOWN VALVES ================= */}

      
      {/* XV-2701 */}
      <Valve
        className="XV-2701"
        tag="XV_2701"
        x={621}
        y={384}
        isClosed={valves.XV_2701}
        toggle={toggleValve}
        r={90}
      />

      {/* XV-2702 */}
      <Valve
        className="XV-2702"
        tag="XV_2702"
        x={1181}
        y={254}
        isClosed={valves.XV_2702}
        toggle={toggleValve}
      />

      {/* XV-2703 */}
      <Valve
        className="XV-2703"
        tag="XV_2703"
        x={1181}
        y={144}
        isClosed={valves.XV_2703}
        toggle={toggleValve}
      />

      {/* XV-2704 */}
      <Valve
        className="XV-2704"
        tag="XV_2704"
        x={681}
        y={169}
        isClosed={valves.XV_2704}
        toggle={toggleValve}
      />

      



      
        {/* ================= CONTROL VALVES SVG ================= */}
        

         {/* FCV-2701 */}
        <div
            style={{ position: "absolute", left: 250, top: 406}}
            onMouseEnter={() => setHoveredValve("FCV_2701")}
            onMouseLeave={() => setHoveredValve(null)}
            onClick={() => openPanel("FCV_2701")}
          >

            {hoveredValve === "FCV_2701" && (
              <div style={tagStyle}>
                FCV_2701
              </div>
            )}

            <svg width="80" height="50" viewBox="0 0 200 220" className="FCV-2701">
                    
          <defs>
            <linearGradient id="metal_2701">
              <stop offset="0%" stopColor="#bdc3c7" />
              <stop offset="50%" stopColor="#ecf0f1" />
              <stop offset="100%" stopColor="#7f8c8d" />
            </linearGradient>
          </defs>


          <path d="M20 60 A80 60 0 0 1 180 60 L180 90 L20 90 Z"
            fill="#eb2a11" stroke="#3498db" strokeWidth="2" />

          <rect x="95" y="90" width="10" height="70" fill="#3d5f2a" />

          <polygon points="20,200 100,150 20,110"
            fill="url(#metal_2701)" stroke="#7f8c8d" strokeWidth="2" />

          <polygon points="180,200 100,150 180,110"
            fill="url(#metal_2701)" stroke="#7f8c8d" strokeWidth="2" />

        </svg>
      </div>
      
        {/* ================= CONTROL VALVES SVG ================= */}
        

         {/* FCV-2702 */}
        <div
            style={{ position: "absolute", left: 860, top: 136}}
            onMouseEnter={() => setHoveredValve("FCV_2702")}
            onMouseLeave={() => setHoveredValve(null)}
            onClick={() => openPanel("FCV_2702")}
          >

            {hoveredValve === "FCV_2702" && (
              <div style={tagStyle}>
                FCV_2702
              </div>
            )}

            <svg width="80" height="50" viewBox="0 0 200 220" className="FCV-2702">
                    
          <defs>
            <linearGradient id="metal_2702">
              <stop offset="0%" stopColor="#bdc3c7" />
              <stop offset="50%" stopColor="#ecf0f1" />
              <stop offset="100%" stopColor="#7f8c8d" />
            </linearGradient>
          </defs>


          <path d="M20 60 A80 60 0 0 1 180 60 L180 90 L20 90 Z"
            fill="#eb2a11" stroke="#3498db" strokeWidth="2" />

          <rect x="95" y="90" width="10" height="70" fill="#3d5f2a" />

          <polygon points="20,200 100,150 20,110"
            fill="url(#metal_2702)" stroke="#7f8c8d" strokeWidth="2" />

          <polygon points="180,200 100,150 180,110"
            fill="url(#metal_2702)" stroke="#7f8c8d" strokeWidth="2" />

        </svg>
      </div>


         {/* FCV-2703 */}
        <div
            style={{ position: "absolute", left: 546, top: 116, transform: "rotate(270deg)", transformOrigin: "center"}}
            onMouseEnter={() => setHoveredValve("FCV_2703")}
            onMouseLeave={() => setHoveredValve(null)}
            onClick={() => openPanel("FCV_2703")}
          >

            {hoveredValve === "FCV_2703" && (
              <div style={tagStyle}>
                FCV_2703
              </div>
            )}

            <svg width="80" height="50" viewBox="0 0 200 220" className="FCV-2703">
                    
          <defs>
            <linearGradient id="metal_2703">
              <stop offset="0%" stopColor="#bdc3c7" />
              <stop offset="50%" stopColor="#ecf0f1" />
              <stop offset="100%" stopColor="#7f8c8d" />
            </linearGradient>
          </defs>


          <path d="M20 60 A80 60 0 0 1 180 60 L180 90 L20 90 Z"
            fill="#eb2a11" stroke="#3498db" strokeWidth="2" />

          <rect x="95" y="90" width="10" height="70" fill="#3d5f2a" />

          <polygon points="20,200 100,150 20,110"
            fill="url(#metal_2703)" stroke="#7f8c8d" strokeWidth="2" />

          <polygon points="180,200 100,150 180,110"
            fill="url(#metal_2703)" stroke="#7f8c8d" strokeWidth="2" />

        </svg>
      </div>


      {/* ================= CONTROL VALVES SVG ================= */}
        

         {/* FCV-2704 */}
        <div
            style={{ position: "absolute", left: 752, top: 596}}
            onMouseEnter={() => setHoveredValve("FCV_2704")}
            onMouseLeave={() => setHoveredValve(null)}
            onClick={() => openPanel("FCV_2704")}
          >

            {hoveredValve === "FCV_2704" && (
              <div style={tagStyle}>
                FCV_2704
              </div>
            )}

            <svg width="80" height="50" viewBox="0 0 200 220" className="FCV-2704">
                    
          <defs>
            <linearGradient id="metal_2704">
              <stop offset="0%" stopColor="#bdc3c7" />
              <stop offset="50%" stopColor="#ecf0f1" />
              <stop offset="100%" stopColor="#7f8c8d" />
            </linearGradient>
          </defs>


          <path d="M20 60 A80 60 0 0 1 180 60 L180 90 L20 90 Z"
            fill="#eb2a11" stroke="#3498db" strokeWidth="2" />

          <rect x="95" y="90" width="10" height="70" fill="#3d5f2a" />

          <polygon points="20,200 100,150 20,110"
            fill="url(#metal_2704)" stroke="#7f8c8d" strokeWidth="2" />

          <polygon points="180,200 100,150 180,110"
            fill="url(#metal_2704)" stroke="#7f8c8d" strokeWidth="2" />

        </svg>
      </div>


        
        {/* ================= CONTROL VALVE FACEPLATES ================= */}
          {openPanels.map((tag, index) => (
            <ControlValveControlPanel
              key={tag}
              tag={tag}
              data={valveData?.[tag] ?? DEFAULT_VALVES?.[tag]}
              update={updateValveData}
              close={() => closePanel(tag)}
              defaultPosition={{
                x: 300 + index * 40,
                y: 270 + index * 40
              }}
            />
          ))}

           {/* ================= PUMPS CONTROL VALVE FACEPLATES ================= */}
          {openPumpPanels.map((tag, index) => (
            <PumpFaceplate
              key={tag}
              tag={tag}
              close={() => closePumpPanel(tag)}
              defaultPosition={{
                x: 300 + index * 40,
                y: 270 + index * 40
              }}
            />
          ))}




      {/* ================= CONTROL VALVE OUTPUTS ================= */}


      <ValveOutput
        value={Number(valveData?.FCV_2701?.opening || 0)}
        x={272}
        y={453}
      />


      <ValveOutput
        value={Number(valveData?.FCV_2702?.opening || 0)}
        x={882}
        y={182}
      />

      <ValveOutput
        value={Number(valveData?.FCV_2703?.opening || 0)}
        x={605}
        y={135}
      />

      <ValveOutput
        value={Number(valveData?.FCV_2704?.opening || 0)}
        x={775}
        y={645}
      />


    <Transmitter
        tag="FIC_2701"
        value={[FIC_2701]}
        x={142}
        y={71}
        unit="BPM"
        max={35}
        HH={34}
        H={30}
        L={0}
        LL={0}
        c="lime"
        description="FLOWRATE OF NAPHTHA FROM V-101 THROUGH P-102A/B TO V-301 (STABILIZER FEED SURGE/BUFFER TANK)"
      />


      <Transmitter
        tag="PT_2701"
        value={[PT_2701]}
        x={252}
        y={71}
        unit="MPa"
        max={1}
        HH={0.8}
        H={0.5}
        L={0}
        LL={0}
        c="lime"
        description="PRESSURE OF NAPHTHA FROM V-101 THROUGH P-102A/B TO V-301 (STABILIZER FEED SURGE/BUFFER TANK)"
      />


      <Transmitter
        tag="TT_2701"
        value={[TT_2701]}
        x={370}
        y={71}
        unit="°C"
        max={600}
        HH={580}
        H={555}
        L={0}
        LL={0}
        c="lime"
        description="TEMPERATURE OF NAPHTHA FROM V-101 THROUGH P-102A/B TO V-301 (STABILIZER FEED SURGE/BUFFER TANK)"
      />

    <Transmitter
        tag="FIC_2702"
        value={[FIC_2702]}
        x={142}
        y={131}
        unit="BPM"
        max={35}
        HH={34}
        H={30}
        L={0}
        LL={0}
        c="lime"
        description="FLOWRATE OF NAPHTHA FROM V-102 THROUGH P-104A/B TO V-301 (STABILIZER FEED SURGE/BUFFER TANK)"
      />


      <Transmitter
        tag="PT_2702"
        value={[PT_2702]}
        x={252}
        y={131}
        unit="MPa"
        max={1}
        HH={0.8}
        H={0.5}
        L={0}
        LL={0}
        c="lime"
        description="PRESSURE OF NAPHTHA FROM V-102 THROUGH P-104A/B TO V-301 (STABILIZER FEED SURGE/BUFFER TANK)"
      />


      <Transmitter
        tag="TT_2702"
        value={[TT_2702]}
        x={370}
        y={131}
        unit="°C"
        max={600}
        HH={580}
        H={555}
        L={0}
        LL={0}
        c="lime"
        description="TEMPERATURE OF NAPHTHA FROM V-102 THROUGH P-104A/B TO V-301 (STABILIZER FEED SURGE/BUFFER TANK)"
      />

      <Transmitter
        tag="PT_2703"
        value={[PT_2703]}
        x={492}
        y={181}
        unit="MPa"
        max={1}
        HH={0.8}
        H={0.5}
        L={0}
        LL={0}
        c="lime"
        description="PRESSURE OF STABILIZER SURGE TANK (V-301) VESSEL"
      />

      <Transmitter
        tag="PT_2704"
        value={[PT_2704]}
        x={962}
        y={131}
        unit="MPa"
        max={1}
        HH={0.8}
        H={0.5}
        L={0}
        LL={0}
        c="lime"
        description="PRESSURE OF NITROGEN FROM NITROGEN HEADER TO TOP OF V-301"
      />

      <Transmitter
        tag="FIC_2704"
        value={[FIC_2704]}
        x={1072}
        y={131}
        unit="BPM"
        max={35}
        HH={34}
        H={30}
        L={0}
        LL={0}
        c="lime"
        description="FLOWRATE OF NITROGEN FROM NITROGEN HEADER TO TOP OF V-301"
      />

      <Transmitter
        tag="FIC_2705"
        value={[FIC_2705]}
        x={742}
        y={78}
        unit="SCF/M"
        max={35}
        HH={34}
        H={30}
        L={0}
        LL={0}
        c="lime"
        description="FLOWRATE OF GAS FROM STABILIZER SURGE TANK (V-301) TO FLARE HEADER"
      />


      <Transmitter
        tag="PT_2705"
        value={[PT_2705]}
        x={900}
        y={78}
        unit="MPa"
        max={1}
        HH={0.8}
        H={0.5}
        L={0}
        LL={0}
        c="lime"
        description="PRESSURE OF GAS FROM STABILIZER SURGE TANK (V-301) TO FLARE HEADER"
      />


      <Transmitter
        tag="TT_2705"
        value={[TT_2705]}
        x={1030}
        y={78}
        unit="°C"
        max={600}
        HH={580}
        H={555}
        L={0}
        LL={0}
        c="lime"
        description="TEMPERATURE OF GAS FROM STABILIZER SURGE TANK (V-301) TO FLARE HEADER"
      />


      <Transmitter
        tag="FIC_2706"
        value={[FIC_2706]}
        x={142}
        y={399}
        unit="BPM"
        max={35}
        HH={34}
        H={30}
        L={0}
        LL={0}
        c="lime"
        description="FLOWRATE OF PRODUCED WATER FROM STABILIZER SURGE TANK (V-301) TO SEWAGE TREATMENT SYSTEM"
      />


      <Transmitter
        tag="PT_2706"
        value={[PT_2706]}
        x={332}
        y={399}
        unit="MPa"
        max={1}
        HH={0.8}
        H={0.5}
        L={0}
        LL={0}
        c="lime"
        description="PRESSURE OF PRODUCED WATER FROM STABILIZER SURGE TANK (V-301) TO SEWAGE TREATMENT SYSTEM"
      />


      <Transmitter
        tag="TT_2706"
        value={[TT_2706]}
        x={430}
        y={399}
        unit="°C"
        max={600}
        HH={580}
        H={555}
        L={0}
        LL={0}
        c="lime"
        description="TEMPERATURE OF PRODUCED WATER FROM STABILIZER SURGE TANK (V-301) TO SEWAGE TREATMENT SYSTEM"
      />

      <Transmitter
        tag="FIC_2707"
        value={[FIC_2707]}
        x={845}
        y={635}
        unit="BPM"
        max={35}
        HH={34}
        H={30}
        L={0}
        LL={0}
        c="lime"
        description="FLOWRATE OF NAPHTHA FROM V-301 THROUGH P-301A/B TO T-301"
      />


      <Transmitter
        tag="PT_2707"
        value={[PT_2707]}
        x={600}
        y={682}
        unit="MPa"
        max={1}
        HH={0.8}
        H={0.5}
        L={0}
        LL={0}
        c="lime"
        description="PRESSURE OF NAPHTHA FROM V-301 THROUGH P-301A/B TO T-301"
      />


      <Transmitter
        tag="TT_2707"
        value={[TT_2707]}
        x={600}
        y={559}
        unit="°C"
        max={600}
        HH={580}
        H={555}
        L={0}
        LL={0}
        c="lime"
        description="TEMPERATURE OF NAPHTHA FROM V-301 THROUGH P-301A/B TO T-301"
      />

      <Transmitter
        tag="TT_2708"
        value={[TT_2708]}
        x={990}
        y={189}
        unit="°C"
        max={600}
        HH={580}
        H={555}
        L={0}
        LL={0}
        c="lime"
        description="TEMPERATURE OF NAPHTHA FROM V-301 THROUGH E-301A/B  TO T-301"
      />


      <Transmitter
        tag="TT_2709"
        value={[TT_2709]}
        x={993}
        y={269}
        unit="°C"
        max={600}
        HH={580}
        H={555}
        L={0}
        LL={0}
        c="lime"
        description="TEMPERATURE OF STABILIZED NAPHTHA PRODUCT FROM BUTTOM OF STABILIZER TOWER"
      />

      <Transmitter
        tag="TT_27010"
        value={[TT_27010]}
        x={983}
        y={649}
        unit="°C"
        max={600}
        HH={580}
        H={555}
        L={0}
        LL={0}
        c="lime"
        description="TEMPERATURE OF STABILIZED NAPHTHA PRODUCT FROM BUTTOM OF STABILIZER TOWER"
      />






            <LevelTransmitterIndicator
              tag="LT_2701"
              totalLevel={500}
              inflows={[FIC_2701+FIC_2708+FIC_2702*0.91]}
              outflows={[FIC_2707]}
              inflowTags={["FIC_2701", "FIC_2708", "FIC_2702"]}
              outflowTags={["FIC_2707"]}
              responseFactor={0.05}
              columnX={395}
              columnY={225}
              columnWidth={262}
              columnHeight={91}
              textX={686}
              textY={230}
              showFlow={true}
              backgroundOpacity={0.00}
              liquidOpacity={0.7}
              service="naphtha"
            />

            <LevelTransmitterIndicator
              tag="LT_2702"
              totalLevel={500}
              inflows={[FIC_2701+FIC_2702*0.11]}
              outflows={[FIC_2706]}
              inflowTags={["FIC_2701", "FIC_2702"]}
              outflowTags={["FIC_2706"]}
              responseFactor={0.05}
              columnX={395}
              columnY={225}
              columnWidth={262}
              columnHeight={91}
              textX={286}
              textY={230}
              showFlow={true}
              backgroundOpacity={0.00}
              liquidOpacity={0.2}
              service="water"
            />


            <Pump
              tag="P-301A"
              x={474}
              y={577}
              rpm={1800}
              bladeCount={pumpData?.["P-301A"]?.bladeCount || 3}
              size={pumpData?.["P-301A"]?.size || 45}
              onClick={openPumpPanel}
            />

            <Pump
              tag="P-301B"
              x={474}
              y={665}
              rpm={1800}
              bladeCount={pumpData?.["P-301B"]?.bladeCount || 3}
              size={pumpData?.["P-301B"]?.size || 45}
              onClick={openPumpPanel}
            />









    </div>
  );
}

export default SurgeTank;